/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import AppDispatcher from '../dispatcher/AppDispatcher';
import AppConstants from '../constants/AppConstants';
import { EventEmitter } from 'events';
import assign from 'object-assign';

import Authentication from '../authentication/awsAuthentication';

const CHANGE_EVENT = 'securityChange';

let _store = {
    users : [],
    userAttributes : null,
    lastFailure : null
};

class UserStoreClass extends EventEmitter {
    constructor() {
        super();
        console.log("[User Store] - initialisation");
    }

    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    notify() {
        UserStore.emit(CHANGE_EVENT);
    }

    user() {
      var u = Authentication.currentUser();
      var p = UserStore.profile() ;

      if (!u || !p) {
        console.log("[UserStore] no current user authenticated");

        return null ;
      }

      // console.log("[UserStore] get current user: ", u);
      return {user : u, profile: p};
    }

    users() {
      return _store.users ;
    }

    setUserAttributes(atts) {
      _store.userAttributes = atts ;
    }

    userAttributes() {
      return _store.userAttributes;
    }

    profile() {
      var role = window.sessionStorage.getItem("profileRole") ;
      if (!role) { // must have a role
        return null ;
      }

      var dealerId = window.sessionStorage.getItem("profileDealer");

      switch (role) {
        case "ADMIN" : return {role : role, dealerId : null};
        case "TECHSUPPORT" : return {role : role, dealerId : null};
        case "DEALER_ADMIN" :
            if (!dealerId) {
              return null ;
            }
            return {role : role, dealerId : dealerId};
        case "DEALER" :
            if (!dealerId) {
              return null ;
            }
            return {role : role, dealerId : dealerId};
        default : return null ;
      }
    }

    setProfile(profileRole, profileDealerid) {
      console.log("[UserStore] setProfile: ", profileRole, profileDealerid);
      if (profileRole) {
        window.sessionStorage.setItem("profileRole", profileRole);
      }
      else {
        window.sessionStorage.removeItem("profileRole");
      }
      if (profileDealerid) {
        window.sessionStorage.setItem("profileDealer", profileDealerid);
      }
      else {
        window.sessionStorage.removeItem("profileDealer");
      }
    }

    hasRole(role) {
      var u = UserStore.user() ;
      if (!u) {
        return false ;
      }
      var r = u.profile.role;
      return r.toUpperCase() === role.toUpperCase() ;
    }

    isDealer() {
      return this.hasRole("dealer_admin") || this.hasRole("dealer");
    }

    isAdministrator() {
      return this.hasRole("admin");
    }

    isTechSupport() {
      return this.hasRole("techsupport");
    }

    canEditJobs() {
      return this.hasRole("admin") || this.hasRole("techsupport");
    }

    lastFailure() {
      return _store.lastFailure ;
    }
}

const UserStore = new UserStoreClass();


AppDispatcher.register((payload) => {
  const action = payload.action;

  switch (action.actionType) {
    case AppConstants.USER_BY_EMAIL:
        console.log("[UserStore] USER_BY_EMAIL: ", action);
        UserStore.setProfile(action.result.role, action.result.dealerId);
        UserStore.emit(CHANGE_EVENT);
        break ;

    case AppConstants.ALL_USERS:
        console.log("[UserStore] ALL_USERS: ", action);
        _store.users = action.result ;
        UserStore.emit(CHANGE_EVENT);
        break ;

    case AppConstants.ALL_USERS_ERR:
        console.log("[UserStore] ALL_USERS_ERR: ", action);
        _store.users = [];
        _store.lastFailure = action.error ;
        UserStore.emit(CHANGE_EVENT);
        break ;

    case AppConstants.USER_BY_EMAIL_ERR:
        console.log("[UserStore] USER_BY_EMAIL_ERR: ", action);
        _store.lastFailure = action.error ;
        UserStore.emit(CHANGE_EVENT);
        break ;

    case AppConstants.USER_LOGOUT:
        UserStore.setProfile(null,null);
        UserStore.emit(CHANGE_EVENT);
        break ;

    default:
        return true;
  }
});
export default UserStore;




// WEBPACK FOOTER //
// ./src/app/stores/UserStore.js